/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type IntegrationSyncInfoStatus = typeof IntegrationSyncInfoStatus[keyof typeof IntegrationSyncInfoStatus];


export const IntegrationSyncInfoStatus = {
  available: 'available',
  planned: 'planned',
} as const;
